<script>
    import Icon from '../icons/Icon.svelte';

    export let isOpen = false;
    export let store = null;
    export let onCopyWelcome = () => {};
    export let onCopyText = () => {};
    export let onClose = () => {};
</script>

{#if isOpen && store}
    <div class="modal-overlay" on:click|self={onClose}>
        <div class="modal-card">
            <header class="modal-header">
                <div class="header-icon-box">
                    <Icon name="check-circle" size={32} />
                </div>
                <h3>Restaurante Cadastrado com Sucesso!</h3>
                <p>O acesso do cliente já está liberado. Envie as credenciais abaixo para o proprietário pelo WhatsApp.</p>
            </header>

            <div class="credentials-card">
                <div class="cred-row">
                    <span class="cred-label">Restaurante:</span>
                    <strong class="cred-val">{store.name}</strong>
                </div>

                <div class="cred-row">
                    <span class="cred-label">E-mail de Login:</span>
                    <span class="cred-val font-mono">{store.email}</span>
                </div>

                <div class="cred-row">
                    <span class="cred-label">Senha Inicial:</span>
                    <span class="cred-val font-mono highlight-pwd">{store.password || '••••••••'}</span>
                </div>

                <div class="cred-row">
                    <span class="cred-label">Chave de Acesso Rápido:</span>
                    <div class="key-copy-group">
                        <span class="key-pill">{store.access_key}</span>
                        <button
                            type="button"
                            class="btn-copy-sm"
                            title="Copiar chave"
                            on:click={() => onCopyText(store.access_key, 'Chave de acesso copiada!')}
                        >
                            <Icon name="copy" size={12} />
                        </button>
                    </div>
                </div>

                <div class="cred-row">
                    <span class="cred-label">Cardápio Digital:</span>
                    <a
                        href="/cardapio/{store.slug}"
                        target="_blank"
                        rel="noreferrer"
                        class="cardapio-link"
                    >
                        /cardapio/{store.slug}
                        <Icon name="eye" size={11} />
                    </a>
                </div>

                <div class="cred-row">
                    <span class="cred-label">Mensalidade:</span>
                    <span class="cred-val text-green">R$ {parseFloat(store.monthly_price || 97).toFixed(2)}/mês</span>
                </div>
            </div>

            <footer class="modal-footer">
                <button type="button" class="btn-whatsapp-welcome" on:click={() => onCopyWelcome(store)}>
                    <Icon name="whatsapp" size={16} />
                    <span>Copiar Mensagem Pronta de Boas-Vindas</span>
                </button>

                <button type="button" class="btn-done" on:click={onClose}>
                    Concluir
                </button>
            </footer>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-card {
        background: #FFFFFF;
        border: 1px solid #BBF7D0;
        border-radius: 16px;
        width: 100%;
        max-width: 520px;
        box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        padding: 28px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .modal-header {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .header-icon-box {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        background: #DCFCE7;
        color: #16A34A;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
    }

    .modal-header h3 {
        font-size: 19px;
        font-weight: 800;
        color: #0F172A;
        margin: 0 0 6px 0;
        letter-spacing: -0.3px;
    }

    .modal-header p {
        font-size: 13px;
        color: #64748B;
        margin: 0;
        line-height: 1.45;
    }

    .credentials-card {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 16px 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .cred-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        font-size: 13px;
        border-bottom: 1px solid #E2E8F0;
        padding-bottom: 8px;
    }

    .cred-row:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .cred-label {
        color: #64748B;
        font-size: 12px;
        font-weight: 600;
    }

    .cred-val {
        color: #0F172A;
        font-weight: 700;
    }

    .font-mono {
        font-family: monospace;
    }

    .highlight-pwd {
        color: #D97706;
        background: #FEF3C7;
        padding: 2px 8px;
        border-radius: 4px;
        border: 1px solid #FDE68A;
    }

    .key-copy-group {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .key-pill {
        font-family: monospace;
        font-size: 12px;
        background: #FFFFFF;
        color: #0F172A;
        border: 1px solid #CBD5E1;
        padding: 3px 8px;
        border-radius: 4px;
        font-weight: 600;
    }

    .btn-copy-sm {
        background: none;
        border: none;
        color: #94A3B8;
        cursor: pointer;
        padding: 2px;
        display: flex;
    }

    .btn-copy-sm:hover {
        color: #FF6A00;
    }

    .cardapio-link {
        font-family: monospace;
        font-size: 12px;
        color: #FF6A00;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-weight: 600;
    }

    .cardapio-link:hover {
        text-decoration: underline;
    }

    .text-green {
        color: #16A34A;
    }

    .modal-footer {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .btn-whatsapp-welcome {
        background: #16A34A;
        border: 1px solid #15803D;
        color: #FFFFFF;
        padding: 11px 18px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        transition: all 0.15s ease;
        box-shadow: 0 1px 3px rgba(22, 163, 74, 0.25);
    }

    .btn-whatsapp-welcome:hover {
        background: #15803D;
        box-shadow: 0 3px 8px rgba(22, 163, 74, 0.35);
        transform: translateY(-1px);
    }

    .btn-done {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 9px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-done:hover {
        background: #F8FAFC;
        color: #0F172A;
    }
</style>
